export const STORE_AUTH_TOKEN = 'STORE_AUTH_TOKEN';
